"use client";

import Image from "next/image";
import Link from "next/link";
import { Headset, Mail } from "lucide-react";
import LanguageToggle from "./components/language-toggle";
import { WGL_SUPPORT_PHONE } from "./constants";
import { useWglT } from "./i18n/use-t";

export default function WglHeader({
  children,
}: {
  children?: React.ReactNode;
}) {
  const t = useWglT();
  return (
    <header className="w-full border-b border-b-border">
      <div className="mx-auto flex w-full flex-col gap-4 px-8 py-4 sm:flex-row sm:items-center sm:justify-between lg:max-w-6xl">
        <div className="h-10 min-w-0 sm:h-[75px]">
          <Image
            alt="Washington Gas: A WGL Company"
            className="h-10 w-auto object-contain object-left sm:h-[75px]"
            height={813}
            loading="eager"
            src="/assets/tenants/wgl/header.png"
            width={2604}
          />
        </div>
        {children}
        <div className="flex flex-col gap-3 sm:items-end sm:self-end">
          <div className="flex items-center justify-start text-muted-foreground">
            <div className="flex flex-col justify-start gap-2 text-xs sm:text-sm">
              <div className="flex items-center justify-start gap-2">
                <Headset className="size-4 sm:size-6" />
                <div>
                  <div>{t("header.customerService")}</div>
                  <Link className="font-bold" href="tel:844-927-4427">
                    {WGL_SUPPORT_PHONE}
                  </Link>
                </div>
              </div>
              <div className="flex items-center justify-start gap-2">
                <Mail className="size-4 sm:size-6" />
                <div>
                  <div>{t("header.email")}</div>
                  <Link
                    className="font-bold"
                    href="mailto:customersupport@washgas.com"
                  >
                    customersupport@washgas.com
                  </Link>
                </div>
              </div>
              <div className="flex w-full md:justify-end">
                <LanguageToggle />
              </div>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
}
